/**
 * Converte o valor de um input com `sgtPercentInput` (string "12,50" no FormControl)
 * para `number` JS. Retorna `null` quando o valor é vazio/inválido.
 */
export const parsePercentInputValue = (value: string | number | null | undefined): number | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }
  const parsed = Number(String(value).replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

/**
 * Formata um `number` (vindo da API) para a string aceita pelo input
 * com `sgtPercentInput` — vírgula como separador decimal (pt-BR).
 * Retorna `null` quando o valor é nulo/indefinido.
 */
export const formatPercentInputValue = (
  value: number | null | undefined,
  maximumFractionDigits = 2
): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  if (value === 0) {
    return '0';
  }
  return value.toLocaleString('pt-BR', { maximumFractionDigits });
};
